const translations = {
  "upload.title": "Subir",
  "upload.selectHeader": "Seleccionar encabezado",
  "upload.mapColumns": "Mapear columnas",
  "upload.expectedColumn": "Columnas esperadas",
  "upload.required": "Requerido",
  "upload.dropFile": "Suelta tu archivo aquí",
  "upload.or": "o",
  "upload.browse": "Examinar archivos",
  "upload.downloadTemplate": "Descargar plantilla",
  "upload.fileTypes": "Solo se pueden subir archivos CSV, XLS y XLSX",
  "upload.selectHeaderRow": "Seleccionar fila de encabezado",
  "upload.selectHeaderRowHelp": "Selecciona la fila que contiene los encabezados de las columnas",
  "upload.excelSheetWarning": "Solo se importará la primera hoja (&quot;{{sheet}}&quot;) del archivo de Excel. Para importar varias hojas, sube cada hoja individualmente.",
  "common.cancel": "Cancelar",
  "common.continue": "Continuar",
  "mapping.fileColumn": "Tu columna del archivo",
  "mapping.sampleData": "Tus datos de muestra",
  "mapping.destinationColumn": "Columna de destino",
  "mapping.include": "Incluir",
  "mapping.submit": "Enviar",
  "common.loading": "Cargando...",
  "mapping.requiredColumns": "Por favor incluye todas las columnas requeridas",
  "common.back": "Atrás",
  "common.selectOne": "- Selecciona uno -",
  "common.empty": "- vacío -",
  "success.import": "Importación exitosa",
  "success.upload": "Se ha subido con éxito",
  "common.done": "Listo",
  "success.uploadAnother": "Subir otro archivo",
};

export default translations;
